import React from 'react';

import { defineMessage, useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

import { Text } from '@atlaskit/primitives/compiled';

import { asFormRankingField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

const selectedValue = defineMessage({
	id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.scale-input.view.selected-value',
	defaultMessage: '{selected}/{max}',
	description:
		'Displays the selected scale value out of the maximum, e.g. "7/10". selected is the chosen scale number, max is the highest scale option.',
});

const noValue = defineMessage({
	id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.scale-input.view.no-value',
	defaultMessage: '-/{max}',
	description:
		'Displayed when no scale value has been selected, showing only the maximum scale value, e.g. "-/10".',
});

export const ViewScaleInput = ({ fieldId }: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);

	const intl = useIntl();
	const formField = useFormField({ fieldId });
	const formRankingField = asFormRankingField(formField);

	if (formRankingField === undefined) {
		return <></>;
	}

	const max = formRankingField.options[formRankingField.options.length - 1]?.id ?? '';

	const text =
		formRankingField.value?.number !== undefined
			? intl.formatMessage(selectedValue, { selected: formRankingField.value.number, max })
			: intl.formatMessage(noValue, { max });

	return <Text testId="field-input-scale-view">{text}</Text>;
};
